import QRCode from "react-qr-code";
import DownloadAppStore from "@/assets/images/download-appstore.png";
import DownloadGooglePlay from "@/assets/images/download-googleplay.png";
import { Typography } from "@/components/atoms";

export interface TransportProviderCodePaneProps {
  providerCode: string;
  /** Same driver register link for every Scenario — the code rides along inside it. */
  driverRegisterLink?: string;
}

export const TransportProviderCodePane = ({ providerCode, driverRegisterLink }: TransportProviderCodePaneProps) => (
  <div className="flex flex-col items-center justify-center gap-4 p-4">
    <div className="flex flex-col items-center">
      <Typography variant="h2" className="uppercase text-neutral-black">
        {providerCode}
      </Typography>
      <Typography variant="paragraph" className="text-neutral-dark-gray">
        Transport Provider Code
      </Typography>
    </div>

    {driverRegisterLink && (
      <div className="flex flex-col items-center gap-2">
        <div className="rounded-lg bg-white p-2">
          <QRCode value={driverRegisterLink} style={{ height: "170px", width: "170px" }} />
        </div>
        <Typography variant="paragraph" className="text-center text-neutral-dark-gray">
          Scan with your camera. Carries your code through, so you never type it.
        </Typography>
      </div>
    )}

    <div className="flex flex-wrap items-start justify-center gap-4">
      <a href={driverRegisterLink} target="_blank" rel="noopener noreferrer">
        <img src={DownloadAppStore} alt="Download on the App Store" className="w-[120px]" />
      </a>
      <a href={driverRegisterLink} target="_blank" rel="noopener noreferrer">
        <img src={DownloadGooglePlay} alt="Get it on Google Play" className="w-[135px]" />
      </a>
    </div>
  </div>
);
